// app/javascript/controllers/auto_save_controller.js

import { Controller } from "@hotwired/stimulus";
import * as formSerializer from "../lib/auto_save/form_serializer";
import * as storage from "../lib/auto_save/local_storage";
import * as feedback from "../lib/auto_save/feedback";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.storageKey = this.formTarget.id;
    const data = storage.get(this.storageKey);
    if (data) {
      formSerializer.restore(this.formTarget, data);
      feedback.showUnsavedState(this.formTarget);
    }
  }

  saveToLocalStorage() {
    const data = formSerializer.serialize(this.formTarget);
    storage.set(this.storageKey, data);
    feedback.showUnsavedState(this.formTarget);
  }

  clearLocalStorage() {
    storage.remove(this.storageKey);
    feedback.clearUnsavedState(this.formTarget);
  }
}
